// Sidebar.js
import React, { useState } from "react";
import { Link, useLocation } from "react-router-dom";
import { Menu } from "antd";
import {
  UserOutlined,
  RetweetOutlined,
  ContactsOutlined,
  RiseOutlined,
  SnippetsOutlined,
  ApartmentOutlined,
  FileDoneOutlined,
  FormOutlined,
  SolutionOutlined,
  IdcardOutlined,
  TeamOutlined,
  UserSwitchOutlined,
} from "@ant-design/icons";
import Sider from "antd/es/layout/Sider";

const Sidebar = ({ collapsed }) => {
  const location = useLocation();
  const [openKeys, setOpenKeys] = useState([]);

  const handleOpenChange = (keys) => {
    const latestOpenKey = keys.find((key) => !openKeys.includes(key));
    if (["courses", "enrollment"].includes(latestOpenKey)) {
      setOpenKeys(latestOpenKey ? [latestOpenKey] : []);
    } else {
      setOpenKeys(keys);
    }
  };

  return (
    <Sider
      trigger={null}
      collapsible
      collapsed={collapsed}
      style={{ height: "100vh", position: "sticky" }}
    >
      <Menu
        theme="dark"
        mode="inline"
        selectedKeys={[location.pathname]}
        openKeys={openKeys}
        onOpenChange={handleOpenChange}
      >
        <Menu.Item key="/director-dashboard" icon={<UserOutlined />}>
          <Link to="/director-dashboard" className="text-decoration-none">
            Director Dashboard
          </Link>
        </Menu.Item>

        <Menu.Item key="/employee-exchange" icon={<RetweetOutlined />}>
          <Link to="/employee-exchange" className="text-decoration-none">
            Employee Exchange
          </Link>
        </Menu.Item>

        <Menu.Item key="/skill-development" icon={<RiseOutlined />}>
          <Link to="/skill-development" className="text-decoration-none">
            Skill Development
          </Link>
        </Menu.Item>

        {/* Courses Menu */}
        <Menu.SubMenu key="courses" icon={<SnippetsOutlined />} title="Courses">
          <Menu.Item key="/courses/manage-course" icon={<ApartmentOutlined />}>
            <Link to="/courses/manage-course" className="text-decoration-none">
              Manage Courses
            </Link>
          </Menu.Item>

          <Menu.Item key="/courses/add-new-course" icon={<FileDoneOutlined />}>
            <Link to="/courses/add-new-course" className="text-decoration-none">
              Add New Courses
            </Link>
          </Menu.Item>

          <Menu.Item
            key="/courses/course-categories"
            icon={<ApartmentOutlined />}
          >
            <Link
              to="/courses/course-categories"
              className="text-decoration-none"
            >
              Course Category
            </Link>
          </Menu.Item>

          <Menu.Item key="/courses/coupons" icon={<SnippetsOutlined />}>
            <Link to="/courses/coupons" className="text-decoration-none">
              Coupons
            </Link>
          </Menu.Item>
        </Menu.SubMenu>

        {/* Enrollment Menu */}
        <Menu.SubMenu
          key="enrollments"
          icon={<SnippetsOutlined />}
          title="Enrollments"
        >
          <Menu.Item key="/enrollments/course" icon={<ApartmentOutlined />}>
            <Link to="/enrollments/course" className="text-decoration-none">
              Course Enrollment
            </Link>
          </Menu.Item>

          <Menu.Item
            key="enrollments/enroll-history"
            icon={<FileDoneOutlined />}
          >
            <Link
              to="/enrollments/enroll-history"
              className="text-decoration-none"
            >
              Enrollment History
            </Link>
          </Menu.Item>
        </Menu.SubMenu>
        {/* Approvals Menu with Nested Submenu */}
        {/* <Menu.SubMenu key="approvals" icon={<FileDoneOutlined />} title="Approvals">
            <Menu.Item key="/enrollment/approvals/user" icon={<IdcardOutlined />}>
              <Link to="/enrollment/approvals/user" className="text-decoration-none">
                User Approvals
              </Link>
            </Menu.Item>

            <Menu.Item key="/enrollment/approvals/employee" icon={<TeamOutlined />}>
              <Link to="/enrollment/approvals/employee" className="text-decoration-none">
                Employee Approvals
              </Link>
            </Menu.Item>
          </Menu.SubMenu> */}
        {/* </Menu.SubMenu> */}

        <Menu.Item key="/contact" icon={<ContactsOutlined />}>
          <Link to="/contact" className="text-decoration-none">
            Contact
          </Link>
        </Menu.Item>

        {/* Blog Menu */}
        <Menu.SubMenu key="blogs" icon={<SnippetsOutlined />} title="Blogs">
          <Menu.Item key="/blog/all-blogs" icon={<ApartmentOutlined />}>
            <Link to="/blog/all-blogs" className="text-decoration-none">
              All Blogs
            </Link>
          </Menu.Item>

          <Menu.Item key="/blogs/pending-blogs" icon={<FileDoneOutlined />}>
            <Link to="/blogs/pending-blogs" className="text-decoration-none">
              Pending Blogs
            </Link>
          </Menu.Item>

          <Menu.Item key="/blog/category" icon={<ApartmentOutlined />}>
            <Link to="/blog/category" className="text-decoration-none">
              Blog Category
            </Link>
          </Menu.Item>

          <Menu.Item key="/blog/settings" icon={<SnippetsOutlined />}>
            <Link to="/blog/settings" className="text-decoration-none">
              Blog settings
            </Link>
          </Menu.Item>
        </Menu.SubMenu>

        {/* Users Menu */}
        <Menu.SubMenu
          key="users"
          icon={<SnippetsOutlined />}
          title="Manage Users"
        >
          <Menu.Item key="/users/admin-users" icon={<UserOutlined />}>
            <Link to="/users/admin-users" className="text-decoration-none">
              Manage Admins
            </Link>
          </Menu.Item>

          <Menu.Item key="/users/admin-instructors" icon={<UserOutlined />}>
            <Link
              to="/users/admin-instructors"
              className="text-decoration-none"
            >
              Manage Instructors
            </Link>
          </Menu.Item>

          <Menu.Item key="/users/admin-students" icon={<UserOutlined />}>
            <Link to="/users/admin-students" className="text-decoration-none">
              Manage Students
            </Link>
          </Menu.Item>
        </Menu.SubMenu>

        <Menu.Item key="/addons/all-addons" icon={<ContactsOutlined />}>
          <Link to="/addons/all-addons" className="text-decoration-none">
            Addons
          </Link>
        </Menu.Item>

        {/* Settings */}
        <Menu.SubMenu
          key="settings"
          icon={<SnippetsOutlined />}
          title="Settings"
        >
          <Menu.Item key="/settings/zoom-settings" icon={<ApartmentOutlined />}>
            <Link to="/settings/zoom-settings" className="text-decoration-none">
              Zoom live class settings
            </Link>
          </Menu.Item>

          <Menu.Item key="/settings/custom-page" icon={<ApartmentOutlined />}>
            <Link to="/settings/custom-page" className="text-decoration-none">
              Custom page builder
            </Link>
          </Menu.Item>
        </Menu.SubMenu>
      </Menu>
    </Sider>
  );
};

export default Sidebar;
